var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/Auth/Auth.ts";
import { ApiCallService } from '@gmini/api-call-service';
import * as t from 'io-ts';
import { ApiDomain } from '../domain';
export var Auth;

(function (_Auth) {
  var domain = ApiDomain.domain('Auth', {
    name: "domain",
    sid: "ew0eoz"
  });
  var UserData = _Auth.UserData = t.intersection([t.type({
    id: t.string,
    name: t.string,
    email: t.union([t.string, t["null"]])
  }), t.partial({
    firstName: t.union([t.string, t["null"]]),
    lastName: t.union([t.string, t["null"]]),
    phone: t.union([t.string, t["null"]]),
    companyId: t.union([t.number, t["null"]])
  })]);
  var TokenData = _Auth.TokenData = t.type({
    accessToken: t.string,
    accessTokenExpiresIn: t.number,
    refreshTokenExpiresIn: t.number
  });
  var login = _Auth.login = ApiCallService.create({
    name: 'login',
    getKey: [],
    result: TokenData,
    parentDomain: domain
  });
  var refresh = _Auth.refresh = ApiCallService.create({
    name: 'refresh',
    getKey: [],
    result: TokenData,
    parentDomain: domain
  });
  var logout = _Auth.logout = ApiCallService.create({
    name: 'logout',
    getKey: [],
    result: t.unknown,
    parentDomain: domain
  });
  var User;

  (function (_User) {
    var fetch = _User.fetch = ApiCallService.create({
      name: 'fetch',
      getKey: [],
      result: UserData,
      parentDomain: domain
    });
    var fetchList = _User.fetchList = ApiCallService.create({
      name: 'fetchList',
      getKey: [],
      result: t.array(UserData),
      parentDomain: domain
    });
  })(User || (User = _Auth.User || (_Auth.User = {})));

  var Role;

  (function (_Role) {
    var Item = _Role.Item = t.intersection([t.type({
      id: t.number,
      title: t.string
    }), t.partial({
      description: t.union([t.string, t["null"]])
    })], 'RoleItem');
    var fetchList = _Role.fetchList = ApiCallService.create({
      name: 'fetchList',
      parentDomain: domain,
      result: t.array(Item),
      getKey: function getKey() {
        return '0';
      }
    });
  })(Role || (Role = _Auth.Role || (_Auth.Role = {})));
})(Auth || (Auth = {}));